import type { DynamicColType } from "~/components/planning/dynamicTableData/DynamicTableColumns"
import { Badge, type BadgeVariant } from "./Badge"

export const DATA_TYPE_TOOLTIP =
  "This type is detected from your imported data. To change it, contact us via Intercom"

const variantMap: Record<DynamicColType, { variant: BadgeVariant; label: string }> = {
  number: { variant: "default", label: "Number" },
  date: { variant: "violet", label: "Date" },
  string: { variant: "neutral", label: "Text" },
}

export function DataTypeBadge({ dataType }: { dataType: DynamicColType }) {
  const { variant, label } = variantMap[dataType]
  return (
    <Badge variant={variant} size="sm">
      {label}
    </Badge>
  )
}
